// removed by extract-text-webpack-plugin
module.exports = {"manageGroupsSection":"A9JR-aFMn2ZHPo2H3u5cK","isBack":"GkCI9kVYhr23RLWzRrCQ7","arrow":"_1QQU02w74h8yvALbDj7qZ9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/ManageLink.scss
// module id = 1257
// module chunks = 1